import { configureStore } from '@reduxjs/toolkit';
import unknownReducer from './slices/unknownSlice';
import employeeReducer from './slices/employeeSlice';
import reportReducer from './slices/reportSlice';
import uiReducer from './slices/uiSlice';

export const store = configureStore({
  reducer: {
    unknown: unknownReducer,
    employee: employeeReducer,
    report: reportReducer,
    ui: uiReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
